import { Button, Heading, Text } from "components/common";
import classes from "./Subscription.module.css";
import clsx from "clsx";
import { ProIcon } from "images";
import { useAppContext } from "ContextProvider/ContextProvider";
import { useEffect, useState } from "react";
import axios from "axios";
import { FiCheck, FiCopy, FiMinus, FiPlus, FiChevronDown } from "react-icons/fi";
import Cookies from "js-cookie";

const MONTHLY_PRICE = 12; // $12 per month
const ZARP_RATE = 0.1; // $0.01 per Teme UNS

const getDiscountedPrice = (months, basePrice) => {
  let discount = 0;
  if (months >= 12) {
    discount = 0.15; // 15% discount
  } else if (months >= 6) {
    discount = 0.10; // 10% discount
  } else if (months >= 3) {
    discount = 0.05; // 5% discount
  }
  const totalPrice = basePrice * months;
  return totalPrice - (totalPrice * discount);
};

const cryptos_with_icon = [
  {
      logo: "https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png",
      name: "Ethereum Base",
      currency: "ETHBASE",
      // min: 2, //usd
    },
    {
      logo: "https://s2.coinmarketcap.com/static/img/coins/64x64/5426.png",
      name: "Solana",
      currency: "SOL",
      // min: 2, //usd
    },
    {
      logo: "https://s2.coinmarketcap.com/static/img/coins/64x64/1.png",
      name: "Bitcoin",
      currency: "BTC",
      // min: 12,
    },
    {
      logo: "https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png",
      name: "Ethereum",
      currency: "ETH",
    },
    
    {
      logo: "https://s2.coinmarketcap.com/static/img/coins/64x64/74.png",
      name: "Dogecoin",
      currency: "DOGE",
    },
    {
      logo: "https://s2.coinmarketcap.com/static/img/coins/64x64/328.png",
      name: "Monero",
      currency: "XMR",
    },
   
    {
      logo: "https://s2.coinmarketcap.com/static/img/coins/64x64/825.png",
      name: "USDT Tron",
      currency: "USDTTRC20",
      // min: 10, //usd
    },
    {
      logo: "https://s2.coinmarketcap.com/static/img/coins/64x64/825.png",
      name: "Tether BSC",
      currency: "USDTBSC",
    },
    {
      logo: "https://s2.coinmarketcap.com/static/img/coins/64x64/1839.png",
      name: "Binance Coin (BSC)",
      currency: "BNBBSC",
    },
    {
      logo: "https://s2.coinmarketcap.com/static/img/coins/64x64/1958.png",
      name: "Tron",
      currency: "TRX",
    }
  ]

const Subscription = ({ userData }) => {
  const { myTheme } = useAppContext();
  const [view, setView] = useState(userData?.is_pro ? null : 'pricing'); // pricing, payment, confirmation, null for pro view
  const [selectedCrypto, setSelectedCrypto] = useState(null);
  const [months, setMonths] = useState(1);
  const [paymentInfo, setPaymentInfo] = useState(null);
  const [copySuccess, setCopySuccess] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [paymentStatus, setPaymentStatus] = useState(null); // 'pending', 'completed', 'failed'
  const [isCheckingPayment, setIsCheckingPayment] = useState(false);
  const [useZarpBalance, setUseZarpBalance] = useState(false);

  const [balance, setBalance] = useState(0);

  useEffect(() => {
    const fetchBalance = async () => {
      try {
        const {data} = await axios.get(`${process.env.REACT_APP_API}/balances`, {
          headers: {
            'Authorization': `Bearer ${Cookies.get('token')}`
          }
        });
        // setBalance(response.data.balance || 0);
        console.log(data);  

        let TemeAi = data?.find(item => item.currency_id === 'TemeAi' && item.wallet_type === 'Main');
        setBalance(TemeAi?.available_balance || 0);
      } catch (error) {
        console.error('Failed to fetch balance:', error);
      }
    };

    fetchBalance();
  }, []);

  const handleGetPayment = async () => {
    try {
      const response = await axios.post(`${process.env.REACT_APP_API}/create/order`, {
        currency: useZarpBalance ? 'TemeAi' : selectedCrypto.currency.toLowerCase(),
        num_months: months,
        tier: "pro"
      }, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${Cookies.get('token')}`
        }
      });
      setPaymentInfo(response.data);
      setPaymentStatus('pending');
      setView('confirmation');
    } catch (error) {
      console.error('Payment creation failed:', error);
    }
  };

  const handleCheckPaymentStatus = async () => {
    if (isCheckingPayment) return;
    
    setIsCheckingPayment(true);
    try {
      const response = await axios.get(`${process.env.REACT_APP_API}/check/order/${paymentInfo.order_id}`, {
        headers: {
          'Authorization': `Bearer ${Cookies.get('token')}`
        }
      });
      
      setPaymentStatus(response.data.status);
      
      if (response.data.status === 'completed') {
        // Refresh user data or show success message
        setTimeout(() => {
          window.location.reload();
        }, 2000);
      }
    } catch (error) {
      console.error('Payment status check failed:', error);
    } finally {
      setIsCheckingPayment(false);
    }
  };

  const handleCopyAddress = async (address) => {
    try {
      await navigator.clipboard.writeText(address);
      setCopySuccess(true);
      setTimeout(() => setCopySuccess(false), 2000);
    } catch (err) {
      console.error('Failed to copy:', err);
    }
  };

  const resetView = () => {
    setView(userData?.is_pro ? null : 'pricing');
    setSelectedCrypto(null);
    setMonths(1);
    setPaymentInfo(null);
    setCopySuccess(false);
    setIsDropdownOpen(false);
    setPaymentStatus(null);
    setIsCheckingPayment(false);
    setUseZarpBalance(false);
  };

  // Pro user view (default view when not in pricing/payment/confirmation)
  if (userData?.is_pro && !view) {
    return (
      <div className={clsx(classes.subscriptionCard, classes.proCard)}>
        <div className={classes.proStatus}>
          <div className={classes.proBadge}>
            <ProIcon className={classes.proIcon} />
            <span>PRO MEMBER</span>
          </div>
          <h2 className={classes.welcomeTitle}>Welcome to Pro!</h2>
          <p className={classes.welcomeSubtitle}>
            You have unlimited access to all premium features
          </p>
          
          <div className={classes.subscriptionInfo}>
            <div className={classes.infoItem}>
              <span className={classes.infoLabel}>Current Plan</span>
              <span className={classes.infoValue}>Pro Monthly</span>
            </div>
            <div className={classes.infoItem}>
              <span className={classes.infoLabel}>Next Payment</span>
              <span className={classes.infoValue}>{userData?.nextPaymentDate || 'N/A'}</span>
            </div>
          </div>

          <div className={classes.proFeatures}>
            <div className={classes.proFeatureItem}>
              <FiCheck size={20} color="var(--Primitive-Default)" />
              <span>Access to Premium AI Models</span>
            </div>
            <div className={classes.proFeatureItem}>
              <FiCheck size={20} color="var(--Primitive-Default)" />
              <span>Unlimited Messages & Conversations</span>
            </div>
            <div className={classes.proFeatureItem}>
              <FiCheck size={20} color="var(--Primitive-Default)" />
              <span>Priority Support & Updates</span>
            </div>
          </div>

          <div className={classes.extendSubscription}>
            <h3 className={classes.extendTitle}>Extend Your Subscription</h3>
        
            <Button 
              primary 
              className={classes.actionButton}
              onClick={() => setView('payment')}
            >
              Extend Now
            </Button>
          </div>
        </div>
      </div>
    );
  }

  // Pricing View
  if (view === 'pricing') {
    return (
      <div className={clsx(classes.subscriptionCard, classes.pricingCard)}>
        <div className={classes.features}>
          {[
            // {
            //   icon: '🎁',
            //   title: 'Special Teme UNS Bonus',
            //   desc: 'Get 100 Teme UNS tokens for each month of subscription',
            //   highlight: true,
            //   compact: true
            // },
            {
              icon: '✨',
              title: 'Premium AI Models',
              desc: 'Access advanced AI models with enhanced capabilities'
            },
            {
              icon: '💬',
              title: 'Unlimited Messages',
              desc: 'No restrictions on conversation length or history'
            },
            {
              icon: '⚡',
              title: 'Priority Support',
              desc: 'Get faster responses and dedicated assistance'
            }
          ].map((feature, index) => (
            <div key={index} className={clsx(classes.feature, feature.highlight && classes.highlightedFeature, feature.compact && classes.compactFeature)}>
              <span className={classes.featureIcon}>{feature.icon}</span>
              <div className={classes.featureContent}>
                <h3 className={classes.featureTitle}>{feature.title}</h3>
                <p className={classes.featureDesc}>{feature.desc}</p>
                {feature.highlight && (
                  <div className={classes.bonusTag}>
                    <span className={classes.bonusIcon}>🎯</span>
                    <span className={classes.bonusText}>Limited Time Offer!</span>
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>

        <Button 
          primary 
          className={classes.actionButton}
          onClick={() => setView('payment')}
        >
          {userData?.is_pro ? 'Extend Subscription' : 'Upgrade to Pro'}
        </Button>
      </div>
    );
  }

  // Payment View
  if (view === 'payment') {
    const totalPrice = getDiscountedPrice(months, MONTHLY_PRICE);
    const originalPrice = MONTHLY_PRICE * months;
    const discount = originalPrice - totalPrice;
    const zarpBonus = months * 100;
    const zarpEquivalent = Math.ceil(totalPrice / ZARP_RATE); // Convert USD to Teme UNS
    
    return (
      <div className={classes.subscriptionCard}>
        <div className={classes.paymentHeader}>
          <h2 className={classes.welcomeTitle}>Unparalleled AI Experience</h2>
          <div className={classes.priceContainer}>
            <div className={classes.mainPrice}>
              <span className={classes.amount}>
                {useZarpBalance ? `${zarpEquivalent} Teme UNS` : `$${totalPrice.toFixed(2)}`}
              </span>
              <span className={classes.period}>
                for {months} {months === 1 ? 'month' : 'months'}
              </span>
              {useZarpBalance && (
                <span className={classes.usdEquivalent}>
                  ≈ ${totalPrice.toFixed(2)} USD
                </span>
              )}
            </div>
            {discount > 0 && (
              <div className={classes.discountInfo}>
                <span className={classes.originalPrice}>
                  Original price: {useZarpBalance ? `${Math.ceil(originalPrice / ZARP_RATE)} Teme UNS` : `$${originalPrice.toFixed(2)}`}
                </span>
                <span className={classes.savings}>
                  Save {useZarpBalance ? `${Math.ceil(discount / ZARP_RATE)} Teme UNS` : `$${discount.toFixed(2)}`}
                </span>
              </div>
            )}
            {/* <div className={classes.bonusInfo}>
              <div className={classes.bonusHeader}>
                <span className={classes.bonusIcon}>🎁</span>
                <span className={classes.bonusTitle}>Special Bonus</span>
              </div>
              <div className={classes.bonusAmount}>
                <span className={classes.bonusNumber}>+{zarpBonus}</span>
                <span className={classes.bonusCurrency}>Teme UNS</span>
              </div>
              <div className={classes.bonusSubtext}>Free tokens with your subscription!</div>
            </div> */}
          </div>
        </div>

        <div className={classes.paymentForm}>
          <div className={classes.formGroup}>
            <div className={classes.paymentMethodToggle}>
              {/* <div className={classes.toggleContainer}>
                <button 
                  className={clsx(classes.toggleButton, !useZarpBalance && classes.active)}
                  onClick={() => setUseZarpBalance(false)}
                >
                  Crypto
                </button>
                <button 
                  className={clsx(classes.toggleButton, useZarpBalance && classes.active)}
                  onClick={() => setUseZarpBalance(true)}
                >
                  Teme UNS Balance
                </button>
              </div> */}
              {useZarpBalance && (
                <div className={classes.zarpBalanceInfo}>
                  <span className={classes.balanceLabel}>Available Balance:</span>
                  <span className={classes.balanceAmount}>{balance || 0} TemeAi</span>
                  {balance < zarpEquivalent && (
                    <span className={classes.insufficientBalance}>
                      Insufficient balance
                    </span>
                  )}
                </div>
              )}
            </div>
          </div>

          {!useZarpBalance && (
            <div className={classes.formGroup}>
              <label>Cryptocurrency</label>
              <div className={classes.cryptoSelect}>
                <div 
                  className={clsx(classes.cryptoSelectHeader, isDropdownOpen && classes.active)}
                  onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                >
                  {selectedCrypto ? (
                    <>
                      <div className={classes.selectedCrypto}>
                        <img src={selectedCrypto.logo} alt={selectedCrypto.name} />
                        <span>{selectedCrypto.name}</span>
                        {selectedCrypto.min && <span className={classes.minAmount}>(Min ${selectedCrypto.min})</span>}
                      </div>
                    </>
                  ) : (
                    <span className={classes.placeholder}>Select payment method</span>
                  )}
                  <FiChevronDown className={clsx(classes.dropdownIcon, isDropdownOpen && classes.open)} />
                </div>
                
                {isDropdownOpen && (
                  <div className={classes.cryptoDropdown}>
                    {cryptos_with_icon.map(crypto => (
                      <div
                        key={crypto.currency}
                        className={clsx(
                          classes.cryptoOption,
                          selectedCrypto?.currency === crypto.currency && classes.selected
                        )}
                        onClick={() => {
                          setSelectedCrypto(crypto);
                          setIsDropdownOpen(false);
                        }}
                      >
                        <img src={crypto.logo} alt={crypto.name} />
                        <span>{crypto.name}</span>
                        {crypto.min && <span className={classes.minAmount}>(Min ${crypto.min})</span>}
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
          )}

          <div className={classes.formGroup}>
            <label>Subscription Duration</label>
            <div className={classes.durationSelector}>
              <button 
                onClick={() => setMonths(m => Math.max(1, m - 1))}
                disabled={months <= 1}
              >
                <FiMinus />
              </button>
              <span>{months} {months === 1 ? 'month' : 'months'}</span>
              <button onClick={() => setMonths(m => m + 1)}>
                <FiPlus />
              </button>
            </div>
          </div>

          <div className={classes.buttonGroup}>
            <Button
              primary
              className={classes.actionButton}
              disabled={(!useZarpBalance && !selectedCrypto) || (useZarpBalance && balance < zarpEquivalent)}
              onClick={handleGetPayment}
            >
              {useZarpBalance 
                ? (balance < zarpEquivalent 
                    ? `Insufficient Teme UNS Balance (${balance} / ${zarpEquivalent})`
                    : 'Pay with Teme UNS Balance')
                : 'Make Payment'}
            </Button>
            <Button
              secondary
              className={classes.actionButton}
              onClick={resetView}
            >
              Start Over
            </Button>
          </div>
        </div>
      </div>
    );
  }

  // Confirmation View
  if (view === 'confirmation') {
    return (
      <div className={classes.subscriptionCard}>
        <div className={classes.confirmationHeader}>
          <h2 className={classes.welcomeTitle}>Complete Your Payment</h2>
          {paymentStatus === 'completed' ? (
            <div className={classes.successMessage}>
              <FiCheck className={classes.successIcon} />
              <p>Payment Successful! Redirecting...</p>
            </div>
          ) : (
            <p className={classes.welcomeSubtitle}>
              Please send the exact amount to the following address
            </p>
          )}
        </div>

        <div className={classes.paymentDetails}>
          <div className={classes.detailGroup}>
            <label>Amount to Send</label>
            <div className={classes.cryptoAmount}>
              <img src={selectedCrypto?.logo} alt={selectedCrypto?.name} />
              <span>{paymentInfo?.pay_amount} {paymentInfo?.pay_currency.toUpperCase()}</span>
            </div>
          </div>

          <div className={classes.detailGroup}>
            <label>Wallet Address</label>
            <div className={classes.addressBox}>
              <span>{paymentInfo?.pay_address}</span>
              <button 
                onClick={() => handleCopyAddress(paymentInfo?.pay_address)}
                title="Copy address"
              >
                {copySuccess ? <FiCheck /> : <FiCopy />}
              </button>
            </div>
          </div>

          <div className={classes.warning}>
            ⚠️ Important: Send only {paymentInfo?.pay_currency.toUpperCase()} to this address. 
            Other cryptocurrencies will be lost.
          </div>

          <Button 
            primary
            className={classes.actionButton}
            onClick={handleCheckPaymentStatus}
            disabled={isCheckingPayment || paymentStatus === 'completed'}
          >
            {isCheckingPayment ? 'Checking Status...' : 'Check Payment Status'}
          </Button>

          {paymentStatus === 'pending' && (
            <Button 
              secondary
              className={classes.actionButton}
              onClick={() => setView('pricing')}
            >
              Start Over
            </Button>
          )}
        </div>
      </div>
    );
  }

  // Default view for non-pro users
  return (
    <div className={clsx(classes.subscriptionCard, classes.pricingCard)}>
      <div className={classes.features}>
        {[
          {
            icon: '✨',
            title: 'Premium AI Models',
            desc: 'Access advanced AI models with enhanced capabilities'
          },
          {
            icon: '💬',
            title: 'Unlimited Messages',
            desc: 'No restrictions on conversation length or history'
          },
          {
            icon: '⚡',
            title: 'Priority Support',
            desc: 'Get faster responses and dedicated assistance'
          }
        ].map((feature, index) => (
          <div key={index} className={classes.feature}>
            <span className={classes.featureIcon}>{feature.icon}</span>
            <div className={classes.featureContent}>
              <h3 className={classes.featureTitle}>{feature.title}</h3>
              <p className={classes.featureDesc}>{feature.desc}</p>
            </div>
          </div>
        ))}
      </div>

      <Button 
        primary 
        className={classes.actionButton}
        onClick={() => setView('payment')}
      >
        Upgrade to Pro
      </Button>
    </div>
  );
};

export default Subscription;
